var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { defaultElementMap, colorMap } from './constants';
var BaseTypography = function (_a) {
    var children = _a.children, color = _a.color, className = _a.className, as = _a.as, variant = _a.variant, type = _a.type, automationId = _a.automationId, rest = __rest(_a, ["children", "color", "className", "as", "variant", "type", "automationId"]);
    var passedStyle = rest.style, restProps = __rest(rest, ["style"]);
    var cssClass = "".concat(type, "-").concat(variant);
    var textColor = color ? "var(".concat(colorMap[color], ")") : undefined;
    var Element = (as || defaultElementMap[type][variant] || 'span');
    var style = __assign({ color: textColor }, (passedStyle || {}));
    return (_jsx(Element, __assign({ className: classNames(cssClass, className), style: style }, restProps, { "data-automation-id": automationId, children: children })));
};
// Headings
export var Heading4xl = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "4xl" }))); };
export var Heading3xl = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "3xl" }))); };
export var Heading2xl = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "2xl" }))); };
export var HeadingXl = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "xl" }))); };
export var HeadingL = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "l" }))); };
export var HeadingM = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "m" }))); };
export var HeadingS = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "s" }))); };
export var HeadingXs = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "xs" }))); };
export var HeadingXxs = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "heading", variant: "xxs" }))); };
// Text
export var Text3xl = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "text", variant: "3xl" }))); };
export var Text2xl = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "text", variant: "2xl" }))); };
export var TextXl = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "text", variant: "xl" }))); };
export var TextL = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "text", variant: "l" }))); };
export var TextM = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "text", variant: "m" }))); };
export var TextS = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "text", variant: "s" }))); };
// Links
export var LinkL = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "link", variant: "l" }))); };
export var LinkM = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "link", variant: "m" }))); };
export var LinkS = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "link", variant: "s" }))); };
// Labels
export var LabelL = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "label", variant: "l" }))); };
export var LabelM = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "label", variant: "m" }))); };
export var LabelS = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "label", variant: "s" }))); };
export var LabelXs = function (props) { return (_jsx(BaseTypography, __assign({}, props, { type: "label", variant: "xs" }))); };
